import React, { useContext } from "react"
import { Navigate, Outlet } from "react-router-dom"
import {AuthContext} from '../context/Auth'

export const PrivateRoute = () => {
    const {signed, isAdmin} = useContext(AuthContext)

    // Verifica se está logado E se é admin
    return signed && isAdmin ? <Outlet/> : <Navigate to='/'/>
}